// src/sign_in_files/Step3.jsx
import React, { useState, useEffect } from 'react';
import { FIELD_LIMITS } from './DesignSystem';
import fundraiserApi from '../services/fundraiserApi';

// In Step3.jsx - add userId to props (around line 5-15)
const Step3 = ({
  onSuccess,
  onError,
  onLoading,
  onSubmitting,
  fundraiserId,
  onBack,
  isLoading,
  isSubmitting,
  apiError,
  generatedStory,
  userId  // ✅ ADD THIS LINE - it's missing!
}) => {
  // ============ STATE ============
  const [formData, setFormData] = useState({
    story: '',
    addDocuments: false,
    consentInsurance: true,
    agreeTerms: false,
  });

  const [fieldErrors, setFieldErrors] = useState({});
  const [isGeneratingStory, setIsGeneratingStory] = useState(false);
  const [title, setTitle] = useState('');
  const [autoGenerated, setAutoGenerated] = useState(false);

  // ============ AUTO-GENERATE STORY ON COMPONENT MOUNT ============
   useEffect(() => {
    
    if (!userId) {
      
    }
    if (!fundraiserId) {
     
    }
  }, [userId, fundraiserId]); 



useEffect(() => {

  if (fundraiserId && !formData.story && !autoGenerated && !isGeneratingStory) {
    
    autoGenerateStory();
  }
}, [fundraiserId, formData.story, autoGenerated, isGeneratingStory]); // ✅ Add ALL dependencies

  const autoGenerateStory = async () => {
    try {
      setIsGeneratingStory(true);
      setAutoGenerated(true);
      const storyResult = await fundraiserApi.generateStory(fundraiserId);
      if (storyResult?.success) {
        const storyContent = extractStoryContent(storyResult);
        
        if (storyContent) {
          
          handleInputChange('story', storyContent);
        } else {
          
        }
      }
    } catch (error) {
     
      // Don't show error to user - this is a background operation
    } finally {
      setIsGeneratingStory(false);
    }
  };

  const extractStoryContent = (response) => {
    // Check for story content in different possible response fields
    return response?.raw || 
           response?.story || 
           response?.storyHtml || 
           response?.data?.story || 
           response?.data?.raw || 
           response?.data?.storyHtml ||
           response?.content ||
           response?.text ||
           '';
  };

 
  
  const validateField = (field, value) => {
    let error = '';
    
    switch (field) {
      case 'story':
        if (!value?.trim()) error = 'Story is required';
        else if (value.length < FIELD_LIMITS.story.min) {
          error = `Story must be at least ${FIELD_LIMITS.story.min} characters`;
        }
        break;
      case 'agreeTerms':
        if (!value) error = 'You must agree to the terms and conditions';
        break;
      default:
        break;
    }
    
    return error;
  };

  const validateForm = () => {
    const newFieldErrors = {};
    
    const storyError = validateField('story', formData.story);
    if (storyError) newFieldErrors.story = storyError;
    
    const agreeTermsError = validateField('agreeTerms', formData.agreeTerms);
    if (agreeTermsError) newFieldErrors.agreeTerms = agreeTermsError;

    setFieldErrors(newFieldErrors);
    return Object.keys(newFieldErrors).length === 0;
  };

  // ============ HANDLERS ============
  
  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (fieldErrors[field]) {
      setFieldErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handleBlur = (field) => {
    const error = validateField(field, formData[field]);
    setFieldErrors(prev => ({ ...prev, [field]: error }));
  };

  const handleUseGeneratedStory = async () => {
    if (!fundraiserId) {
      onError('Fundraiser ID not found. Please save basic details first.');
      return;
    }
    
    try {
      setIsGeneratingStory(true);
      onError('');
      
 
      const storyResult = await fundraiserApi.generateStory(fundraiserId);
     
      if (storyResult?.success) {
        const storyContent = extractStoryContent(storyResult);
        
        if (storyContent) {
          
          handleInputChange('story', storyContent);
          onError(''); // Clear any errors
        } else {
         
          onError('Story was generated but no content was returned. Please try again or write your own story.');
        }
      } else {
        throw new Error(storyResult?.message || 'Failed to generate story');
      }
    } catch (error) {
     
      onError(error?.message || 'Failed to generate story. Please try again.');
    } finally {
      setIsGeneratingStory(false);
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (!validateForm()) {
    onError('Please fill all required fields correctly.');
    return;
  }

  if (!fundraiserId) {
    onError('Fundraiser ID not found. Please go back to step 1.');
    return;
  }

  try {
    onSubmitting(true);
    onError('');

   

    // ✅ API 1: Submit Story
    const storyData = {
      title: title || 'Medical Fundraiser',
      storyHtml: formData.story,
      story: formData.story,
      addDocuments: formData.addDocuments,
      add_documents: formData.addDocuments,
      consentInsurance: formData.consentInsurance,
      consent_insurance: formData.consentInsurance,
      agreeTerms: formData.agreeTerms,
      agree_terms: formData.agreeTerms
    };

    const storyResult = await fundraiserApi.submitStory(fundraiserId, storyData);

    if (!storyResult?.success) {
      throw new Error(storyResult?.message || 'Failed to submit story');
    }




    
    const submitResult = await fundraiserApi.submitFundraiser({
      userId: userId,  // Make sure userId is passed to Step3
      fundraiserId: fundraiserId
    });

    if (submitResult?.success) {
    
      onSuccess();
    } else {
      throw new Error(submitResult?.message || 'Failed to publish fundraiser');
    }

  } catch (error) {

    
    let errorMessage = error?.message || 'Something went wrong. Please try again.';
    if (error?.error) errorMessage = error.error;
    if (error?.response?.data?.message) errorMessage = error.response.data.message;

    onError(errorMessage);
  } finally {
    onSubmitting(false);
  }
};

  // ============ RENDER HELPERS ============
  
  const getSubmitButtonText = () => {
    if (isSubmitting) return 'Publishing...';
    return 'Publish Fundraiser';
  };

  const isButtonDisabled = isLoading || isSubmitting || isGeneratingStory;

  // ============ RENDER ============
  
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Fundraiser ID Display */}
     

      {/* Auto-generate Status */}
      

      {/* Story Generator Button */}
      
      
      {/* Story Textarea */}
      <div>
        <label className="block text-sm font-semibold text-gray-800 mb-2 text-left">
          Your Story <span className="text-red-500">*</span>
        </label>
        <textarea
          name="story"
          value={formData.story}
          onChange={(e) => handleInputChange('story', e.target.value)}
          onBlur={() => handleBlur('story')}
          placeholder="Tell your story... Share details about the situation, why you need help, and how donations will be used."
          className={`
            w-full px-3.5 py-2.5 rounded-lg border-2 transition-all duration-300
            focus:outline-none focus:ring-1 focus:ring-gsg-teal/30 focus:border-gsg-teal
            placeholder:text-gray-400 text-gray-900 text-sm
            ${fieldErrors.story 
              ? 'border-red-500 focus:border-red-500 focus:ring-red-500/30' 
              : 'border-gray-200 hover:border-gray-300'
            }
          `}
          rows={8}
          maxLength={FIELD_LIMITS.story.max}
          required
        />
        {fieldErrors.story && (
          <p className="mt-1 text-xs text-red-600 text-left">
            {fieldErrors.story}
          </p>
        )}
        <div className="flex justify-between mt-1">
          <span className="text-xs text-gray-500">
            Minimum {FIELD_LIMITS.story.min} characters
          </span>
          <span className="text-xs text-gray-500">
            {formData.story.length}/{FIELD_LIMITS.story.max}
          </span>
        </div>
      </div>

      {/* Checkboxes */}
      <div className="space-y-4">
  <div className="flex items-start space-x-3">
    <input
      type="checkbox"
      id="agreeTerms"
      checked={formData.agreeTerms}
      onChange={(e) => handleInputChange('agreeTerms', e.target.checked)}
      className="mt-1 h-5 w-5 text-gsg-teal rounded border-gray-300 focus:ring-gsg-teal focus:ring-offset-0"
      required
    />
    <label htmlFor="agreeTerms" className="text-sm text-gray-700 text-left">
      I agree to all{' '}
      <a 
        href="/terms-and-conditions" 
        onClick={(e) => {
          e.preventDefault();
          // You can use navigate if you have access to the navigate function
          // Or window.location for simple navigation
          window.open('/terms-and-conditions', '_blank');
        }}
        className="text-gsg-teal hover:underline font-medium cursor-pointer"
        target="_blank"
        rel="noopener noreferrer"
      >
        terms and conditions
      </a>
      , including that funds raised will be used solely for the stated purpose.
    </label>
    {fieldErrors.agreeTerms && (
      <p className="mt-1 text-xs text-red-600 text-left">
        {fieldErrors.agreeTerms}
      </p>
    )}
  </div>
  
  <div className="flex items-start space-x-3">
    <input
      type="checkbox"
      id="consentInsurance"
      checked={formData.consentInsurance}
      onChange={(e) => handleInputChange('consentInsurance', e.target.checked)}
      className="mt-1 h-5 w-5 text-gsg-teal rounded border-gray-300 focus:ring-gsg-teal focus:ring-offset-0"
    />
    <label htmlFor="consentInsurance" className="text-sm text-gray-700 text-left">
      I consent to receiving insurance and financial service offers from trusted partners (optional)
    </label>
  </div>
  
  <div className="flex items-start space-x-3">
    <input
      type="checkbox"
      id="addDocuments"
      checked={formData.addDocuments}
      onChange={(e) => handleInputChange('addDocuments', e.target.checked)}
      className="mt-1 h-5 w-5 text-gsg-teal rounded border-gray-300 focus:ring-gsg-teal focus:ring-offset-0"
    />
    <label htmlFor="addDocuments" className="text-sm text-gray-700 text-left">
      I will add medical documents to increase trust (recommended)
    </label>
  </div>
</div>

      {/* Action Buttons */}
      <div className="flex justify-between mt-6 pt-5 border-t border-gray-100">
        <button
          type="button"
          onClick={onBack}
          disabled={isButtonDisabled}
          className="px-6 py-2.5 rounded-lg border-2 border-gray-200 text-gray-700 font-semibold text-sm hover:bg-gray-50 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          ← Back
        </button>
        
        <button
          type="submit"
          disabled={isButtonDisabled || !formData.story.trim()}
          className={`
            px-6 py-2.5 rounded-lg transition-all duration-300 font-semibold text-sm
            ${isButtonDisabled || !formData.story.trim()
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-gradient-to-r from-gsg-teal to-gsg-teal-dark text-white hover:shadow-md hover:shadow-gsg-teal/25'
            }
            flex items-center justify-center
          `}
        >
          {isSubmitting ? (
            <>
              <svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
              {getSubmitButtonText()}
            </>
          ) : (
            getSubmitButtonText()
          )}
        </button>
      </div>

      {/* Footer */}
      <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <div className="flex items-start space-x-2">
          <svg className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-xs text-blue-700 text-left">
            Your information is secure and will only be used for fundraising purposes.
          </p>
        </div>
      </div>
    </form>
  );
};

export default Step3;